import { getEnv } from '@rtvloco/platform/env';
/**
 * Inspector Client Application Constants
 *
 * Centralizes all magic numbers and configuration constants.
 * Every value is typed and documented for auditability.
 */

/** Application display name */
export const APP_NAME = 'SMARTTT Inspector' as const;

/** Application version — set at build time via VITE_APP_VERSION */
export const APP_VERSION: string =
  getEnv('VITE_APP_VERSION', '0.0.0-dev');

// ---------------------------------------------------------------------------
// Layout dimensions (pixels)
// ---------------------------------------------------------------------------

/** Sidebar width when fully expanded */
export const SIDEBAR_WIDTH_OPEN = 260;

/** Sidebar width in rail/collapsed mode */
export const SIDEBAR_WIDTH_RAIL = 60;

/** Right detail panel width */
export const RIGHT_PANEL_WIDTH = 320;

/** Minimum main content area width before sidebar collapses to rail */
export const MIN_CONTENT_WIDTH = 800;

// ---------------------------------------------------------------------------
// Polling & connectivity
// ---------------------------------------------------------------------------

/** Default polling interval for GraphQL queries (ms) */
export const POLL_INTERVAL_MS = 30_000;

/** WebSocket keepAlive ping interval (ms) */
export const WS_KEEPALIVE_MS = 30_000;

/** Token silent renew interval threshold (seconds) */
export const TOKEN_REFRESH_INTERVAL_S = 30;

/** Maximum retry attempts for WebSocket reconnection */
export const MAX_RETRY_ATTEMPTS = Infinity;

/** Initial backoff delay for retries (ms) */
export const RETRY_INITIAL_DELAY_MS = 1_000;

/** Maximum backoff delay for retries (ms) */
export const RETRY_MAX_DELAY_MS = 30_000;

// ---------------------------------------------------------------------------
// Pagination
// ---------------------------------------------------------------------------

/** Default page size for list views */
export const DEFAULT_PAGE_SIZE = 50;

/** Maximum page size allowed by the API */
export const MAX_PAGE_SIZE = 200;

// ---------------------------------------------------------------------------
// Storage keys
// ---------------------------------------------------------------------------

/** localStorage key for theme preference */
export const STORAGE_KEY_THEME = 'inspector.theme';

/** localStorage key for locale preference */
export const STORAGE_KEY_LOCALE = 'inspector.locale';

/** localStorage key for sidebar collapsed state */
export const STORAGE_KEY_SIDEBAR = 'inspector.sidebar.collapsed';

// ---------------------------------------------------------------------------
// Date / Time formats
// ---------------------------------------------------------------------------

/** Date format for display (ISO 8601 date) */
export const DATE_FORMAT = 'yyyy-MM-dd';

/** Time format for display (HH:mm:ss) */
export const TIME_FORMAT = 'HH:mm:ss';

/** DateTime format for display */
export const DATETIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';

// ---------------------------------------------------------------------------
// Inspector-specific constants
// ---------------------------------------------------------------------------

/** Beacon data retention window (days) — mirrors backend GDPR policy */
export const BEACON_RETENTION_DAYS = 30;

/** Default fraud candidate score threshold for highlighting */
export const FRAUD_SCORE_THRESHOLD = 0.75;
